var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.7033 10.1725C17.7033 9.66267 17.6619 9.1501 17.5738 8.64856H10.4998V11.5366H14.5507C14.3826 12.468 13.8425 13.292 13.0516 13.8156V15.6895H15.4684C16.8876 14.3832 17.7033 12.4542 17.7033 10.1725Z",
  fill: "#4285F4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4997 17.5C12.5224 17.5 14.2282 16.8358 15.471 15.6894L13.0542 13.8155C12.3818 14.273 11.5138 14.532 10.5024 14.532C8.54586 14.532 6.88691 13.212 6.29167 11.4373H3.79773V13.3691C5.07088 15.9016 7.66403 17.5 10.4997 17.5Z",
  fill: "#34A853"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.28897 11.4373C5.97482 10.5059 5.97482 9.4973 6.28897 8.56587V6.63409H3.79779C2.73407 8.75326 2.73407 11.25 3.79779 13.3691L6.28897 11.4373Z",
  fill: "#FBBC04"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4997 5.46843C11.5689 5.4519 12.6023 5.85424 13.3767 6.59277L15.5179 4.45157C14.1621 3.17842 12.3626 2.47846 10.4997 2.50051C7.66403 2.50051 5.07088 4.09883 3.79773 6.63411L6.28891 8.56588C6.8814 6.78843 8.54311 5.46843 10.4997 5.46843Z",
  fill: "#FF666B"
})));
export default SvgGoogle;